import { createContext, type RefObject } from "react";

type ParticipantSearchContextType = {
    search: string;
    setSearch: (value: string) => void;
    debouncedSearch: string;
    inputRef: RefObject<HTMLInputElement | null>;
};

export const participantSearchContext = createContext<ParticipantSearchContextType | undefined>(
    undefined,
);
